(function () {
  angular.module('app.widgets.products.product-all-usage').component('appProductAllUsage', {
    bindings: {
      consumableSummarizationList: '<',
      customer: '<',
      eligibleForDeviceLicenses: '<?',
      hasOverduePurchaseAuth: '<?',
      legacyProductList: '<?',
      offersList: '<?',
      onCreatePurchaseAuth: '&',
      productList: '<',
      refreshCustomer: '&?',
    },
    controller,
    templateUrl: 'app/widgets/products/all-usage/product-all-usage.component.html',
  });

  /* @ngInject */
  function controller(_, $scope, CUSTOMER_SEGMENT, feature, ProductUsage, User) {
    const vm = this;
    _.assign(vm, {
      $onInit,
      CUSTOMER_SEGMENT,
      customerHasLegacyDeviceLicenses: false,
      customerHasSharedDeviceLicenses: false,
      showCreatePAModal,
      User,
    });

    function $onInit() {
      // Block PA creation if there is an enterprise migration in progress.
      // Check if isEditable is defined, it should be, but don't want the absence of it to
      // put us in migration mode.
      if (vm.customer.migrating) {
        vm.customer.migrating = true;
        vm.customer.canCreatePA = false;
      }
      vm.fetchingConsumptionData = true;
      if (vm.consumableSummarizationList) {
        vm.consumableSummarizationList.$promise
          .then(() => {
            vm.consumableUsageDataAvailable = true;
          })
          .finally(() => {
            vm.enterpriseProductUsage = new ProductUsage({
              consumableSummarizationList: vm.consumableSummarizationList,
              productList: _.filter(vm.productList.items, {
                customerSegment: CUSTOMER_SEGMENT.ENTERPRISE,
              }),
            });
            vm.teamProductUsage = new ProductUsage({
              consumableSummarizationList: vm.consumableSummarizationList,
              legacyProductList: vm.legacyProductList,
              productList: _.filter(vm.productList.items, {
                customerSegment: CUSTOMER_SEGMENT.TEAM,
              }),
            });
            _.forEach(vm.legacyProductList, (item) => {
              if (_.invoke(item, 'product.hasDeviceLicense')) {
                vm.customerHasLegacyDeviceLicenses = true;
              }
            });
            if (vm.productList.hasSharedDeviceLicenseProducts()) {
              vm.customerHasSharedDeviceLicenses = true;
            }
            vm.fetchingConsumptionData = false;
          });
      }
      if (vm.customer.canCreatePA) {
        vm.offersList.$promise
          .then((responseData) => {
            vm.offers = responseData;
            vm.hasValidTeamOffers = vm.offers.teamOffers.length > 0;
            vm.hasValidEnterpriseOffers = vm.offers.evipOffers.length > 0;
          })
          .catch(() => {
            vm.failedToLoadOffers = true;
          });
      }
    }

    /* === Create Purchase Authorization ===*/
    function showCreatePAModal(event, customerSegment) {
      event.preventDefault();

      vm.onCreatePurchaseAuth({
        offersMode: customerSegment === CUSTOMER_SEGMENT.TEAM ? 'TEAM' : 'EVIP',
      });
    }
  }
})();
